import _ from 'underscore';

import { incrementRouterSpaceReactKey } from '../../app/actions/spaces/IncrementRouterSpaceReactKeyAction';
import { getAppStore } from '../../app/AppStore';
import { FeatureFlags } from '../FeatureFlags';
import { ILocLinkifierModel } from '../filters/LocLinkifierFilter';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { L10n } from '../L10n/L10n';
import { IDataSourceDetailInfo } from '../models/IDataSourceInfo';
import { Module } from '../Module';
import { RemoteRefreshAgents } from '../resources/RemoteRefreshAgents';
import { IGetRemoteRefreshAgentsResult, IRemoteRefreshAgent } from '../ServerApi/requests/GetRemoteRefreshAgentsRequest';
import { RefreshModeTypes } from '../ServerApi/types/IRemoteRefreshProperties';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ChangeDatasourceRefreshModeAction } from './ChangeDatasourceRefreshModeAction';
import { ChangeDatasourceRemoteAgentAction } from './ChangeDatasourceRemoteAgentAction';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { HelpService } from '../../commonInfra/services/HelpService';

export interface IRemoteRefreshPropertiesEditModel {
  refreshMode: string;
  remoteAgentName: string;
}

export interface IRemoteRefreshAgentOption {
  display: string;
  name: string;
  schedulesSyncedAt?: string;   // ISO 8601 formatted string, or null
  launchesSyncClient?: boolean;
  remoteAgentTimeZone?: string; // The time zone of the Tableau Bridge client
}


export namespace ChangeDatasourceRemoteRefreshPropertiesHelper {
  export function buildRemoteAgentsList(remoteAgentResult: IGetRemoteRefreshAgentsResult, datasource?: IDataSourceDetailInfo): IRemoteRefreshAgentOption[] {
    let listContainsExistingAgent = false;

    const agentList: IRemoteRefreshAgentOption[] = _.map(remoteAgentResult.agents, (agent: IRemoteRefreshAgent) => {
      if (datasource && datasource.remoteAgentName && datasource.remoteAgentName === agent.name){
        listContainsExistingAgent = true;
      }

      return {
        display: agent.name,
        name: agent.name,
        schedulesSyncedAt: agent.schedulesSyncedAt,
        remoteAgentTimeZone: agent.remoteAgentTimeZone
      };
    });

    if (!listContainsExistingAgent && datasource && datasource.remoteAgentName) {
      agentList.unshift({
        display: datasource.remoteAgentName,
        name: datasource.remoteAgentName
      });
    }

    return agentList;
  }
}
